export const getFaultBadgeClass = measurementType => ({
  volts: 'badge-volts',
  temp: 'badge-temp',
  amps: 'badge-amps',
}[measurementType] || 'badge-secondary-custom')

export const getDeviceBadgeClass = device => {
  if (!device) return 'badge-secondary-custom'
  if (device.startsWith('alt')) return 'badge-device-alt'
  if (device.startsWith('bat')) return 'badge-device-bat'
  if (device.startsWith('regulator')) return 'badge-device-regulator'
  return 'badge-secondary-custom'
}
